<template>
  <lazy-load #default="{ visible }" @loaded="fetchProducts">
    <template v-if="!visible">
      <product-grid-skeleton/>
    </template>
    <template v-else>
      <product-grid-skeleton v-if="page === 1 && loading"/>
      <div v-if="products?.length" class="mb-3">
        <div class="text-base font-niceone-medium mb-3">{{ $t('product.recommended_products') }}</div>
      </div>
      <grid-products :products="products" :source-data="{...sourceData,ISPLP:true}"/>
      <infinite-load-more v-model="page" :infinite="hasNextPage" :items-length="products?.length" :loading="loading"
                          @change="fetchProducts"/>
    </template>
  </lazy-load>
</template>

<script setup>
import LazyLoad from "@/components/LazyLoad"
import ProductGridSkeleton from "@/components/skeleton/ProductGrid";
import {getRecommendedProductsMutation} from "@/plugins/API/home"
import GridProducts from "@/components/cart/GridProducts"
import InfiniteLoadMore from "@/components/common/InfiniteLoadMore.vue";
import {EVENT_SOURCES} from "@/constants/events";

const props = defineProps({
  data: {
    type: Object,
    default: () => {
    }
  },
  sourceData: {
    type: Object,
    default: {}
  }
})

const {category, productId} = props.data

const PAGE_LIMIT = 50

const page = ref(1)
const hasNextPage = ref(true)
const products = ref([])

const {isLoading: loading, mutateAsync: productsMutateAsync} = getRecommendedProductsMutation()
const fetchProducts = () => {
  productsMutateAsync({category, productId, page: page.value, limit: PAGE_LIMIT}).then(({data}) => {
    products.value = [...products.value, ...(data?.products || [])]
    if (!data?.products?.length || data?.products?.length < PAGE_LIMIT) return hasNextPage.value = false
  })
}
</script>